import React from "react";
import NascarProjections from "./NascarProjections";

export default function XfProjections() {
  return <NascarProjections series="xfinity" />;
}
